// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"cdf1917b","59":"cd74e89f","77":"5b33fb2b","85":"f5322d3d","264":"49fb298b","274":"f6e2a9e0","316":"c01ecdd6","437":"b31237ef","518":"2b39d77f","633":"a9939bd0","741":"6728d49e","789":"d0b04e1a","816":"e262ca28","852":"91b3fa59","967":"70fb20d3","995":"fc20f3c1"}[chunkId] + ".chunk.js";
};